<template>
  <!-- 用户动态 -->
  <div>
    <!-- 头部-->
    <div class="city-child-head">
      <!-- 标题 -->
      <div class="city-child-head-left float-l">
        <div class="city-child-head-icon"></div>
        <span>用户动态</span>
      </div>
    </div>
    <!-- 内容 -->
    <div class="city-content city-content-chunk-box">
      <div class="city-box">
        <dv-scroll-board class="dv-scr-board" :config="config" />
      </div>
    </div>
  </div>
</template>
<script>
import { getSystemMsg } from '../../api/holdMy.js';
export default {

  data() {
    return {
      refreshImgIng: null,   // 刷新定时器
      getData: {
        cityName: this.$route.query.cityName,
        city: this.$route.query.cityName,
      },
      config: {
        header: ['时间', '名称', '内容'],
        data: [],
        rowNum: 23, //表格行数
        headerHeight: 27,
        headerBGC: 'rgba(0,144,255,0.2)', //表头
        oddRowBGC: 'rgba(26, 201, 255, 0)', //奇数行
        evenRowBGC: 'rgba(26, 201, 255, 0', //偶数行
        align: ['left', 'left', 'left'],
        columnWidth: [78],
      }
    }
  },
  components: {},
  created() {

  },
  mounted() {
    this.refreshScale();
  },

  beforeDestroy() {
    clearInterval(this.refreshImgIng);
  },
  methods: {
    // 刷新数据
    refreshScale() {
      this.sSystemMsg();
      this.refreshImgIng = setInterval(() => {
        this.sSystemMsg();
      }, 1000 * 60 * 30)
    },
    // 获取系统信息列表
    sSystemMsg() {
      var dateTo = new Date();
      var types = ['newRequirementTransportMsg', 'vehicleCertificationCompletionMessage', 'driverAuthenticationCompletionMessage', 'orderGetSucMsg', 'shipment', 'orderFinishedMsg'];

      let data = {
        msgtypes: JSON.stringify(types),
        startDate: this.dateChange(-30, this.dataForm(dateTo)),
        endDate: this.dataForm(dateTo),
        ...this.getData
      }
      let that = this;
      getSystemMsg(data).then(res => {
        if (res.result == 0) {
          let userdata = res.userdata;
          // let userdata = [
          //   { time: '10-05 21:00', name: '高盛广场', msg: '闽D23072运单完成！' },
          // ]
          var data1 = [];
          userdata.forEach(element => {
            data1.push([`<span style="color:rgba(255, 255, 255, 0.4980392156862745);">${element.time ? element.time : ""}</span>`, element.name ? element.name : "", element.msg ? element.msg : ""])
          });
          that.config.data = data1;
          that.config = { ...that.config };//关键,展开数组对象重新赋值.不写数据出不来
        }
      }).catch(error => {
        console.log(error);
      })
    },
    // 格式化日期
    dataForm(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      var h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? ('0' + minute) : minute;
      var second = date.getSeconds();
      second = second < 10 ? ('0' + second) : second;
      return y + '-' + m + '-' + d;
    },
    // 日期加减
    dateChange(num = 1, date = false) {
      if (!date) {
        date = new Date();//没有传入值时,默认是当前日期
        date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      }
      date += " 00:00:00";//设置为当天凌晨12点
      date = Date.parse(new Date(date)) / 1000;//转换为时间戳
      date += (86400) * num;//修改后的时间戳
      var newDate = new Date(parseInt(date) * 1000);//转换为时间

      return this.dataForm(newDate);
    }

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/city.scss';

.city-content {
  height: 100%;

  .city-box {
    padding: 0px;
    overflow: hidden;
    width: 100%;

    .dv-scr-board {
      height: 100%;
    }

    .cj-1 {
      margin: 20px 20px;
    }

    .cj-box {
      background: inherit;
      background-color: rgba(26, 201, 255, 0.2980392156862745);
      height: 49px;
      font-size: 20px;
      line-height: 48px;
      padding-left: 10px;
      color: #1AC7FD;
    }

    .cj-box2 {
      width: 49%;

    }

    .cj-righ {
      margin-right: 10px;
    }

    .cj-2 {
      display: flex;
      align-content: center;
      width: 100%;
      margin-top: 15px;
    }
  }

}
</style>
